import { render, staticRenderFns } from "./NewsEventItem.vue?vue&type=template&id=7694d226&scoped=true&"
import script from "./NewsEventItem.vue?vue&type=script&lang=js&"
export * from "./NewsEventItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsEventItem.vue?vue&type=style&index=0&id=7694d226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7694d226",
  null
  
)

export default component.exports